// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"App_mainContainer__3GtbL"};